<template>
  <main>
    <div class="fixed top-0 bottom-0 left-0 right-0 min-h-screen" style="background-color:#0000006E;min-width:100vw;" v-if="isLoading"></div>
    <h1 class="font-semibold text-2xl mb-4">Available Challenges</h1>
    <table v-if="challenges?.length > 0" class="w-full table-auto border-collapse border-2 border-slate-500 px-4">
        <tr>
            <th>Description</th>
            <th>Week</th>
            <th>Batch</th>
            <th>Available On</th>
            <th>Action</th>
        </tr>
        <tr v-for="(challenge, index) in challenges" :key="index">
            <td>{{challenge.description}}</td>
            <td>{{challenge.week}}</td>
            <td>{{challenge.batch_id}}</td>
            <td>{{challenge.available_on}}</td>
            <td>
                <button @click="deleteChallenge(challenge.id, challenge.available_on)" class="rounded cursor-pointer mb-4 text-white font-semibold bg-red-400 px-4 py-2">
                    Delete
                </button>
            </td>
        </tr>
    </table>
    <h2 v-if="!challenges">
        Loading ...
    </h2>
    <h2 v-if="challenges?.length === 0">
        Data not available
    </h2>
  </main>
</template>

<script setup>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import axios from "axios";
import swal from "sweetalert";

const challenges = ref(null);
const isLoading = ref(false);

const fetchChallenge = async () => {
    try {
        const { data } = await axios.get("admin/auth/challenge/available")
        challenges.value = data.payload
    } catch (error) {
        challenges.value = []
        console.log(error)
    }
};

const nowTime = new Date();

// eslint-disable-next-line no-unused-vars
const deleteChallenge = async (id, time) => {
    console.log(nowTime)
    // if (nowTime > new Date(time)) {
    //     swal({
    //         title: "Oops!!",
    //         text: "You can no longer delete this challenge as it is already active"
    //     })
    //     return;
    // }
    isLoading.value = true;
    try {
        const { data } = await axios.post("admin/auth/challenge/delete", {id:id})
        challenges.value = data.payload
        swal({
            title: "Success",
            text: "Challenge removed"
        })
        isLoading.value = false;
    } catch (error) {
        swal({
            title: "Oops!",
            text: "Unable to remove challenge. Please try again."
        })
        isLoading.value = false;
        console.log(error)
    }
}

onMounted(() => {
    fetchChallenge();
})
</script>

<style scoped>
table td, table th {
border: 1px solid #ddd;
padding: 8px;
text-align: center;
}

table {margin: 12px 0;}

table tr:nth-child(even){background-color: #f2f2f2;}

table tr:hover {background-color: #ddd;}
</style>